module.exports = __webpack_public_path__ + "static/media/1 34 krigsskip.933d3933.mp3";